module.exports = __webpack_public_path__ + "img/Vector.9936bd12.svg";